exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".e-grid .e-headercell.customcss[data-v-35b0f130]{padding:0 5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SystemTasks.vue"],"names":[],"mappings":"AACA,iDACI,aAAqB,CACxB","file":"SystemTasks.vue","sourcesContent":["\n.e-grid .e-headercell.customcss[data-v-35b0f130] {\n    padding: 0 5px 0 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35b0f130","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/System/SystemTasks.vue
// module id = 2256
// module chunks = 15